import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { D365SynchroniserResponseDto } from "../models/common/syncData";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class D365SynchronizerService {
  private d365SynchroniserBaseURL = environment.baseUrl + "/D365Synchroniser";
  constructor(private _http: HttpClient) {}

  syncD365ProjectsData(): Observable<D365SynchroniserResponseDto> {
    return this._http.get<D365SynchroniserResponseDto>(
      this.d365SynchroniserBaseURL + "/SyncProjects"
    );
  }

  syncD365EmployeesProfileData(): Observable<D365SynchroniserResponseDto> {
    return this._http.get<D365SynchroniserResponseDto>(
      this.d365SynchroniserBaseURL + "/SyncEmployeesProfile"
    );
  }

  syncAllD365Data(): Observable<D365SynchroniserResponseDto> {
    return this._http.get<D365SynchroniserResponseDto>(
      this.d365SynchroniserBaseURL + "/syncAll"
    );
  }
}
